import socketIO from "socket.io-client";
import { onMount, Show, createSignal } from "solid-js";

const socket = socketIO({
  transports: ["websocket", "polling"] // use WebSocket first, if available
});


export default socket;


export const SocketStatus = () => {
  const [status, setStatus] = createSignal('disconnected');
  const [maintenanceMessage, setMaintenanceMessage] = createSignal<string | null>(null);

  onMount(() => {
    socket.on('connect', () => {
      console.log('connected');
      setStatus('connected');
      setMaintenanceMessage(null);
    });
    socket.on('disconnect', () => {
      setStatus('disconnected');
      console.log('disconnect');
    });
    socket.on('maintenance-mode', (data: { message: string }) => {
      console.log('Maintenance mode:', data);
      setMaintenanceMessage(data.message);
      setStatus('maintenance');
    });
  });

  return (
    <>
      <Show when={maintenanceMessage()}>
        <div class="socket-status" style="position: fixed; top: 20px; left: 50%; transform: translateX(-50%); z-index: 9999; width: 90%; max-width: 600px;">
          <div class="alert alert-warning text-center shadow-lg" role="alert">
            <h4 class="alert-heading">
              <i class="fas fa-tools me-2"></i>
              Maintenance en cours
            </h4>
            <p class="mb-0">{maintenanceMessage()}</p>
          </div>
        </div>
      </Show>
      <Show when={status() === 'disconnected' && !maintenanceMessage()}>
        <div class="socket-status">
          <div class="alert alert-danger" role="alert">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            Connexion au serveur perdue...
          </div>
        </div>
      </Show>
    </>
  );
}